<template>
  <div class="siderbar">
    <ul class="left_nav">
      <li
        v-for="(item,index) in menu"
        :key="index"
        :class="['edit',{'active':activeIndex===index}]"
        @click="goto(item.route,index)"
      >
        <div class="menu-item">
          <img
            class="icon"
            :src="activeIndex===index?item.active:item.inactive"
          />
          <div class="name">{{item.label}}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import aquestion from "@/assets/images/survey/edit/siderbar/question-type-active.png";
import nquestion from "@/assets/images/survey/edit/siderbar/question-type.png";
import appearance from "@/assets/images/survey/edit/siderbar/appearance-active.png";
import nappearance from "@/assets/images/survey/edit/siderbar/appearance.png";
export default {
  data() {
    return {
      activeIndex: 0,
      menu: [
        {
          label: "题型",
          active: aquestion,
          inactive: nquestion,
          route: "survey-edit"
        },
        {
          label: "外观",
          active: appearance,
          inactive: nappearance,
          route: "survey-appearance"
        }
      ]
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  watch: {
    "$route.name"(val) {
      this.activeIndex = this.menu.findIndex(item => item.route === val);
    }
  },
  mounted() {
    this.activeIndex = this.menu.findIndex(
      item => item.route === this.$route.name
    );
  },
  methods: {
    goto(route) {
      this.$router.push({
        name: route,
        params: {
          id: this.id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/variables.less";

.siderbar {
  width: 71px;
  height: 100%;
  overflow: auto;
  background-color: @deepgray;
  position: fixed;
  top: 64px;
  left: 0;
  z-index: 299;
  text-align: center;
  border-right: 1px solid #d8d8d8;

  .left_nav {
    li {
      cursor: pointer;
      margin-bottom: 10px;
      font-size: 12px;
      color: whitesmoke;

      &.active {
        color: #414141;
        background-color: #f8f8f8;
      }

      div.menu-item {
        display: inline-block;
        padding: 8px 15px;
        border-radius: 5px;

        img.icon {
          width: 30px;
        }

        .name {
          padding: 5px 0;
        }
      }
    }
  }
}
</style>
